// extracted by mini-css-extract-plugin
export var bodyRow = "_ce-d";
export var cardColumns = "_ce-e";
export var ellipsesOverflow = "_ce-2";
export var flatBottomCorners = "_ce-3";
export var flatTopCorners = "_ce-4";
export var headerActionsDropdown = "_ce-f";
export var headerBottomRow = "_ce-c";
export var headerTopRow = "_ce-b";
export var orderDetailsWrapper = "_ce-0";
export var orderInfoContainer = "_ce-1";
export var productDetails = "_ce-9";
export var productImage = "_ce-5";
export var responsiveTable = "_ce-8";
export var shipmentContainer = "_ce-a";
export var tableBottomLeft = "_ce-6";
export var tableBottomRight = "_ce-7";
export var trackingLink = "_ce-g";